/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { oktaServerSuggestionsDismiss } from "../funcs/oktaServerSuggestionsDismiss.js";
import { oktaServerSuggestionsList } from "../funcs/oktaServerSuggestionsList.js";
import { oktaServerSuggestionsRestore } from "../funcs/oktaServerSuggestionsRestore.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { ListOktaServerSuggestionsResult } from "../models/components/listoktaserversuggestionsresult.js";
import { OktaServerSuggestion } from "../models/components/oktaserversuggestion.js";
import {
  DismissOktaServerSuggestionRequest,
  DismissOktaServerSuggestionSecurity,
} from "../models/operations/dismissoktaserversuggestion.js";
import {
  ListOktaServerSuggestionsRequest,
  ListOktaServerSuggestionsSecurity,
} from "../models/operations/listoktaserversuggestions.js";
import {
  RestoreOktaServerSuggestionRequest,
  RestoreOktaServerSuggestionSecurity,
} from "../models/operations/restoreoktaserversuggestion.js";
import { unwrapAsync } from "../types/fp.js";

export class OktaServerSuggestions extends ClientSDK {
  /**
   * dismiss oktaServerSuggestions
   *
   * @remarks
   * Dismiss a suggestion currently made to the organization. Remembered until restored, even across Okta reconnects. Requires org:admin and the okta-connections rollout.
   */
  async dismiss(
    request: DismissOktaServerSuggestionRequest,
    security?: DismissOktaServerSuggestionSecurity | undefined,
    options?: RequestOptions,
  ): Promise<OktaServerSuggestion> {
    return unwrapAsync(oktaServerSuggestionsDismiss(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * list oktaServerSuggestions
   *
   * @remarks
   * List the catalog servers suggested from the Okta applications snapshot. Requires org:admin, the okta-connections rollout and a verified identity provider connection.
   */
  async list(
    request?: ListOktaServerSuggestionsRequest | undefined,
    security?: ListOktaServerSuggestionsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListOktaServerSuggestionsResult> {
    return unwrapAsync(oktaServerSuggestionsList(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * restore oktaServerSuggestions
   *
   * @remarks
   * Restore a dismissed suggestion currently made to the organization. Requires org:admin and the okta-connections rollout.
   */
  async restore(
    request: RestoreOktaServerSuggestionRequest,
    security?: RestoreOktaServerSuggestionSecurity | undefined,
    options?: RequestOptions,
  ): Promise<OktaServerSuggestion> {
    return unwrapAsync(oktaServerSuggestionsRestore(
      this,
      request,
      security,
      options,
    ));
  }
}
